module.exports = __webpack_public_path__ + "media/how_fastweb_works/03_succeed-a8e392db.jpg";